// Core components
import { Component, OnInit } from "@angular/core";

// Third party components
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from "file-saver";
import { ToastrService } from 'ngx-toastr';
import { ConfigService } from 'src/app/shared/services/config.service';

// Custom components

@Component({
  selector: 'app-formly-file-downloader-type',
  template: `
    <div *ngIf="files">
      <div *ngFor="let file of files">
        <button class="download-btn-icon" mat-button (click)="onDownload(file)" onclick="this.blur()" mat-stroked-button
         matTooltip="{{ 'common.cta.download' | translate }}">
         <mat-icon fontSet="fal" fontIcon="fa-file-pdf"></mat-icon>
          {{ 'common.cta.download' | translate }}
        </button>
        <a href="{{ file.url }}" target="_blank" matTooltip="{{ 'common.cta.open_new_tab' | translate }}">
          {{ file.originalName }}
        </a>
        ({{ ( file.size / 1024 )?.toFixed(2) }} KB)
      </div>
    </div>
  `,
})

export class FileDownloaderTypeComponent extends FieldType implements OnInit {
  files = [];

  /**
   * Class constructor
   */
  constructor(
    private configService: ConfigService,
    private translateService: TranslateService,
    private toastrService: ToastrService,
  ) {
    super();
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    let docs = [];

    if (this.model && this.model.length) {
      docs = this.model;
    } else if (this.model && this.model.documents && this.model.documents.length) {
      docs = this.model.documents;
    } else {
      this.toastrService.error("Nessun file presente!");
      return;
    }

    if (docs.length) {
      docs.forEach(file => {
        let path = "";
        let url = "";
        // piattaforma 1
        if (file.path.substr(0, 33) === "https://app.archedi.it/documents/") {
          // https://api.archedi.it/uploads/properties/5f8d4974a2a02e1a9488b883/documents/41969250-12f0-11eb-af37-877a6b43bbd3.pdf
          // url = file.path;
          url = `https://api.archedi.it/uploads/properties/${this.model.propertyId}/documents/${file.filename}`;
        } else {
          path = file.path.replace(/src[\\\/]assets/g, 'public');
          path = path.replace(/^\/+/, '');
          url = `${this.configService.apiHost}/${path}`;
        }
        const newFile = {
          ...file,
          url,
        }
        this.files.push(newFile);
      });
    }
  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   *
   */
  onDownload(file: any): void {
    FileSaver.saveAs(file.url, file.originalName);
  }
}
